import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const PurchaseRequisitions = lazy(() => import('./PurchaseRequisitions'));
const PurchaseOrders = lazy(() => import('./PurchaseOrders'));
const PurchaseInvoices = lazy(() => import('./PurchaseInvoices'));
const PurchaseReturns = lazy(() => import('./PurchaseReturns'));
const GoodsReceiptNotes = lazy(() => import('./GoodsReceiptNotes'));
const AiDocuments = lazy(() => import('../AI/AiDocuments'));
const Vendors = lazy(() => import('./Vendors'));
const VendorGroups = lazy(() => import('./VendorGroups'));
const VendorQuotations = lazy(() => import('./VendorQuotations'));
const ProcurementPayments = lazy(() => import('./ProcurementPayments'));

export const procurementRoutes = (
    <React.Fragment key="procurement">
        <Route element={<ProtectedRoute permission="procurement.requisition.view" />}>
            <Route path="/purchase-requisitions" element={<PurchaseRequisitions />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.order.view" />}>
            <Route path="/purchase-orders" element={<PurchaseOrders />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.invoice.view" />}>
            <Route path="/purchase-invoices" element={<PurchaseInvoices />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.return.view" />}>
            <Route path="/purchase-returns" element={<PurchaseReturns />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.payment.view" />}>
            <Route path="/procurement/payments" element={<ProcurementPayments />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.grn.view" />}>
            <Route path="/inventory/grns" element={<GoodsReceiptNotes />} />
        </Route>
        <Route element={<ProtectedRoute permission="crm.vendor.view" />}>
            <Route path="/crm/vendors" element={<Vendors />} />
            <Route path="/crm/vendor-groups" element={<VendorGroups />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.vendor_quote.view" />}>
            <Route path="/vendor-quotations" element={<VendorQuotations />} />
        </Route>
    </React.Fragment>
);
